





































































import { Component, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

import TermsAndConditionsMixin from "@/components/app/global/termsAndConditions/termsAndConditionsMixin";
import HasValidation from "@/mixins/HasValidation";

@Component({
  components: {
    "terms-and-conditions-table": () =>
      import(
        "@/components/app/admin/settings/billing/termsAndConditionsTable.vue"
      )
  },
  computed: {
    ...mapState({
      brandId: (state: any) => state.auth.admin.brandId
    })
  }
})
export default class TermsAndConditionsDetails extends Mixins(
  TermsAndConditionsMixin,
  HasValidation
) {
  private isProcessing = false;
  private urlRegex = /((?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[A-Z0-9+&@#/%=~_|$]))/im;

  // Computed
  public get formIsValid() {
    if (this.isUrl && this.$_.isEmpty(this.tAndC.terms.url)) {
      return false;
    }
    if (this.isUrl && !this.urlRegex.exec(this.tAndC.terms.url)) {
      return false;
    }
    if (!this.isUrl && this.$_.isEmpty(this.tAndC.terms.terms)) {
      return false;
    }

    if (this.hasErrors) return false;
    return true;
  }

  // Methods
  public save() {
    this.isProcessing = true;
    this.create()
      .then(() => {
        if (this.$refs.table) {
          // @ts-ignore
          this.$refs.table.getData();
        }
        this.loadData();
      })
      .finally(() => {
        this.isProcessing = false;
      });
  }

  public get formIsChanged() {
    if (this.$_.isEmpty(this.current)) {
      return this.formIsValid;
    }

    return this.formIsValid && this.hasChange;
  }
}
